import { render, staticRenderFns } from "./answer_done.vue?vue&type=template&id=bf00b7da&scoped=true"
import script from "./answer_done.vue?vue&type=script&lang=js"
export * from "./answer_done.vue?vue&type=script&lang=js"
import style0 from "./answer_done.vue?vue&type=style&index=0&id=bf00b7da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf00b7da",
  null
  
)

export default component.exports